import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsCommercial } from '../../../../selectors/offer';
import { selectHighDemandCoefficient } from '../../../../selectors/publishTerms';
import { DiscountBanner } from '../../components/DiscountBanner';
import { HighDemandBanner } from '../../components/HighDemandBanner';
import * as styles from './HighDemandBannerContainer.css';
import { useDeviceCondition } from '../../../../hooks';

export const HighDemandBannerContainer = (): JSX.Element | null => {
  const highDemandCoefficient = useSelector(selectHighDemandCoefficient);
  const isCommercial = useSelector(selectIsCommercial);
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  if (!highDemandCoefficient || highDemandCoefficient === 1 || !isCommercial) {
    return null;
  }

  if (highDemandCoefficient > 1) {
    return (
      <div className={rootStyle}>
        <HighDemandBanner />
      </div>
    );
  }

  return (
    <div className={rootStyle}>
      <DiscountBanner />
    </div>
  );
};
